// src/pages/Menu/Articulacion/Documents/UploadProjectMinuteModal.jsx
import React from "react";
import { Calendar, Upload, X } from "lucide-react";
import Swal from "sweetalert2";

export default function UploadProjectMinuteModal({
  open,
  minForm,
  setMinForm,
  uploading,
  fileRef,
  projectTitle,
  onClose,
  onUpload,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} aria-hidden />
      <div className="absolute inset-0 grid place-items-center p-6">
        <div
          className="rounded-2xl p-[2px]"
          style={{ background: "linear-gradient(135deg,#E6F0FF 0%,#E6FBFF 100%)" }}
        >
          <div className="w-[min(92vw,38rem)] rounded-2xl overflow-hidden bg-white ring-1 ring-black/5">
            {/* Header */}
            <div
              className="px-5 py-4 text-white"
              style={{ background: "linear-gradient(90deg,#0c3b66,#0488AF)" }}
            >
              <div className="flex items-center justify-between gap-2">
                <div>
                  <div className="text-base font-semibold">Subir minuta</div>
                  {projectTitle ? (
                    <div className="text-xs opacity-90 truncate">
                      Proyecto: <span className="font-medium">{projectTitle}</span>
                    </div>
                  ) : null}
                </div>
                <button
                  className="p-2 rounded-lg hover:bg-white/10"
                  onClick={onClose}
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>

            {/* Body */}
            <div className="px-6 py-5 space-y-4 max-h-[70vh] overflow-y-auto">
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Fecha de la minuta (opcional)
                  </label>
                  <input
                    type="date"
                    value={minForm.date}
                    onChange={(e) =>
                      setMinForm((f) => ({ ...f, date: e.target.value }))
                    }
                    max={new Date().toISOString().split('T')[0]}
                    className="w-full rounded-xl border border-gray-200 px-3 py-2 focus:ring-2 focus:ring-[#0488AF] outline-none"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Título <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={minForm.title}
                    onChange={(e) =>
                      setMinForm((f) => ({ ...f, title: e.target.value }))
                    }
                    className="w-full rounded-xl border border-gray-200 px-3 py-2 focus:ring-2 focus:ring-[#0488AF] outline-none"
                    placeholder="Título de la minuta"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Archivo PDF <span className="text-red-500">*</span>
                </label>
                <input
                  ref={fileRef}
                  type="file"
                  accept="application/pdf"
                  onChange={async (e) => {
                    const selectedFile = e.target.files?.[0] || null;
                    if (selectedFile) {
                      if (selectedFile.type !== 'application/pdf') {
                        await Swal.fire({
                          icon: 'error',
                          title: 'Formato inválido',
                          text: 'Debes subir un archivo PDF',
                        });
                        e.target.value = '';
                        return;
                      }
                      if (selectedFile.size > 15 * 1024 * 1024) {
                        await Swal.fire({
                          icon: 'warning',
                          title: 'Archivo muy grande',
                          html: `El archivo "${selectedFile.name}" es demasiado grande (máx 15 MB).<br/><br/>Por favor, comprime el archivo PDF antes de subirlo.<br/><br/><a href="https://www.ilovepdf.com/es/comprimir_pdf" target="_blank" rel="noopener noreferrer" style="color: #0488AF; text-decoration: underline;">Comprimir PDF aquí</a>`,
                          confirmButtonText: 'Entendido',
                        });
                        e.target.value = '';
                        return;
                      }
                    }
                    setMinForm((f) => ({
                      ...f,
                      file: selectedFile,
                    }));
                  }}
                  className="block w-full text-sm text-gray-700 file:mr-4 file:rounded-xl file:border-0 file:bg-[#0488AF] file:px-4 file:py-2 file:text-white hover:file:bg-[#037a98] transition-colors"
                />
                <p className="mt-1 text-xs text-gray-500">Solo PDF. Máx 15 MB.</p>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-200 bg-white flex justify-end gap-2">
              <button
                onClick={onClose}
                className="h-11 px-4 rounded-xl bg-[#C42251] text-white hover:bg-[#A01D45] text-sm font-semibold transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={onUpload}
                disabled={uploading}
                className={`inline-flex items-center gap-2 h-11 px-4 rounded-xl text-white text-sm font-semibold transition-colors ${
                  uploading ? "bg-gray-400 cursor-not-allowed" : "bg-emerald-600 hover:bg-emerald-700"
                }`}
              >
                {uploading ? (
                  "Subiendo…"
                ) : (
                  <>
                    <Upload className="w-4 h-4" /> Subir minuta
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
